import * as yup from 'yup';

export const schema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().email().required(),
  cellphone: yup.string().required(),
});

export const fieldsForm =  {
    firstName: {
      elementType: 'input',
      controlId: 'registerfirstName',
      value: '',
    },
    lastName: {
      elementType: 'input',
      controlId: 'registerlastName',
      value: '',
    },
    cellphone: {
        elementType: 'input',
        controlId: 'registercellphone',
        value: '',
    },
    email: {
      elementType: 'input',
      controlId: 'registeremail',
      value: '',
    },
  }